import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {StationInfoConfiguration} from "./station-info-configuration";
import {MeasurementsInfoConfiguration} from "./measurements-info-configuration";

export enum StationPopupTabs {
    Info = "info",
    Measurements = "measurements",
    TimeSeries = "time-series",
    Documents = "documents",
    Images = "images"
}

@JsonObject()
export class StationPopupTypeConfiguration {
    /**
     * Identifier of this type
     */
    @JsonProperty()
    declare id: string;

    /**
     * Expression to select stations belonging to this type
     */
    @JsonProperty()
    declare expression: string;

    /**
     * Defines the visible tabs
     */
    @JsonProperty()
    declare tabs: StationPopupTabs[];

    constructor() {}
}

@JsonObject()
export class StationParameterSorting {

    /**
     * ID field name
     */
    @JsonProperty()
    declare baseId: number;

    /**
     * Name field name
     */
    @JsonProperty()
    declare stationParameterNames: string[];

    constructor() {}
}

@JsonObject()
export class StationPopupConfiguration {
    /**
     * Initial width of popup window
     */
    @JsonProperty()
    declare width: number;

    /**
     * Initial height of popup window
     */
    @JsonProperty()
    declare height: number;

    /**
     * Minimum width of the popup window
     */
    @JsonProperty()
    declare minWidth: number;

    /**
     * Minimum height of the popup window
     */
    @JsonProperty()
    declare minHeight: number;

    /**
     * Minimum height in fixed position
     */
    @JsonProperty()
    declare fixedMinHeight: number;

    /**
     * info fields configuration
     */
    @JsonProperty()
    declare stationInfo: StationInfoConfiguration;

    /**
     * info fields configuration
     */
    @JsonProperty()
    declare measurementsInfo: MeasurementsInfoConfiguration;

    /**
     * Object containing semantic-ui-react icon names to get by key.
     * A key could be: parameterTypeName, objectType
     */
    @JsonProperty()
    declare icons: object;

    /**
     *
     */
    @JsonProperty()
    declare types: StationPopupTypeConfiguration[];

    /**
     * Sorting
     */
    @JsonProperty()
    declare timeSeriesSorting: StationParameterSorting[];

    constructor() {}
}
